import * as THREE from 'three';
import { G, M, TINT, HP, glowMat, mesh, mergeBones, stages, boneG } from './kit';
/* ============================================================
   GERIPPE 骨籠 —— BOSS・開合
   ============================================================

   剪影：八根弧骨圍成的籠
   階段：'P1 籠閉合・核心打不到','P2 骨外張・核心全露但邊緣切人','P3 收攏成球・滾（紅）'

   由 `tools/port-bosses.mjs` 從 `enemy_sample_ani.html` 機械移植，
   **不要手改這個檔**：要改造型請改原型再重跑移植器，否則 1:1 就斷了。
   驗證：`node tools/port-bosses.mjs --check`。
   ⚠️ 比對只守得住數字與字串，**動畫對不對只能實看**（圖鑑的開發模式）。 */


/* ── BOSS-10 GERIPPE 骨籠 ── 反轉：保護 → 露出 → 變成武器。
   P1 八根骨向內收攏成籠，核心只露一條縫（打不到）。
   P2 骨向外張開，核心全露 —— 但骨的邊緣開始旋轉切人。
   P3 骨全部貼合成一顆密實的球，開始滾。原本保護它的東西現在是撞你的東西。 */
export function buildGerippe(){
  var GL = glowMat(TINT.red.hex, 2.0), GLV = glowMat(TINT.vio.hex, 2.4);
  var root = new THREE.Group(), ribs = [], i;
  var hub = boneG(root, 0, 3.20, 0);
  for (i = 0; i < 8; i++){
    var a = i*Math.PI * 2/8;
    var rb = boneG(hub, 0, 0, 0); rb.rotation.y = a;
    rb.add(mesh(G.box, M.armor, [0.42,4.80,0.34], [ 0, 0, 2.30], [0.26,0,0]));
    rb.add(mesh(G.box, M.dark,  [0.30,1.60,0.26], [ 0, 2.10, 2.90], [0.62,0,0]));
    rb.add(mesh(G.box, M.dark,  [0.30,1.60,0.26], [ 0,-2.10, 2.90], [-0.62,0,0]));
    rb.add(mesh(G.cone, M.trim, [0.30,0.80,0.30], [0, 2.90, 3.20], [0.9,0,0]));
    var eg = mesh(G.box, GL, [0.10,4.20,0.10], [0.24, 0, 2.44], [0.26,0,0]);
    eg.userData.noMerge = 1; rb.add(eg);
    ribs.push(rb);
  }
  var core = boneG(hub, 0, 0, 0);
  var cm = mesh(G.oct, GLV, [2.20,2.20,2.20], [0,0,0]);
  cm.userData.noMerge = 1; core.add(cm);
  core.add(mesh(G.tor, M.trim, [3.00,3.00,0.34], [0,0,0], [HP,0,0]));
  root.userData.rig = {hub:hub, ribs:ribs, core:core, cm:cm, GL:GL, GLV:GLV};
  return mergeBones(root);
}
export function updGerippe(rig, o, dt){
  stages(rig, o, dt, 1.9);
  var s1 = rig.s1, s2 = rig.s2, i;
  var open = s1*(1 - s2);                            // 只有第二階段是張開的
  for (i = 0; i < 8; i++){
    var rb = rig.ribs[i];
    rb.rotation.x = -0.55*s2 + 0.70*open;
    rb.scale.set(1 + 0.5*s2, 1 - 0.30*s2, 1 + 0.5*s2);
    rb.position.y = -0.30*s2;
  }
  rig.hub.rotation.y += dt*(0.35 + 1.6*open + 3.4*s2);
  rig.hub.rotation.x  = s2 * (o.t*2.2);              // 三階段整顆滾起來
  rig.hub.position.y  = 3.20 - 0.60*s2 + 0.14*Math.sin(o.t*1.2);
  rig.cm.scale.setScalar((0.45 + 0.55*open + 0.30*s2)*(1 + 0.10*Math.sin(o.t*3) + 0.5*o.tel));
  rig.GL.emissiveIntensity  = 0.8 + 2.6*open + 3.4*s2 + 3*o.atk;
  rig.GLV.emissiveIntensity = 1.2 + 2.6*open + 2.0*o.tel;
}